import styled from 'styled-components';

import { GridCellLink } from 'shared/components/Grid/GridCellLink';
import { GridCellProductImage } from 'shared/components/Grid/GridCellProductImage';
import { GridWrapper, GridCellWrapper } from 'shared/components/Grid/styles/GridStyles';
import { IArticleTopShoesSectionProductTemplates } from 'editorial/types/ArticleTopShoesSection';
import { appendLeadingZeroToNumber } from 'editorial/utils/appendLeadingZeroToNumber';
import { variableFontRegular } from 'styles/theme/text';

interface IArticleTopShoesDesktop {
  title: string;
  productTemplates: Array<IArticleTopShoesSectionProductTemplates>;
}

export const ArticleTopShoesDesktop = ({ title, productTemplates }: IArticleTopShoesDesktop) => {
  return (
    <>
      <ArticleTopShoesDesktop.Header>{title}</ArticleTopShoesDesktop.Header>
      <GridWrapper>
        {productTemplates.map(
          ({ condition, id, gridPictureUrl, name, slug, productCategory }, index: number) => (
            <GridCellWrapper key={id}>
              <GridCellLink to={`/${productCategory === 'SHOES' ? 'sneakers' : 'apparel'}/${slug}`}>
                <ArticleTopShoesDesktop.ProductInfo>
                  <ArticleTopShoesDesktop.Number>
                    {appendLeadingZeroToNumber(index + 1)}
                  </ArticleTopShoesDesktop.Number>
                  <ArticleTopShoesDesktop.Name>{name}</ArticleTopShoesDesktop.Name>
                </ArticleTopShoesDesktop.ProductInfo>
                <GridCellProductImage
                  imageSrc={gridPictureUrl}
                  isActiveCell={false}
                  isSellerImage={condition === 'used'}
                  name={name}
                />
              </GridCellLink>
            </GridCellWrapper>
          ),
        )}
      </GridWrapper>
    </>
  );
};

ArticleTopShoesDesktop.Header = styled.h3`
  text-transform: capitalize;
  font-weight: 400;
  ${variableFontRegular({ size: '22px', height: '22px', spacing: '-0.5px' })};
  padding: 70px 0;
`;

ArticleTopShoesDesktop.ProductInfo = styled.div`
  display: grid;
  grid-template-rows: auto;
  grid-column-gap: 16px;
  grid-row-gap: 6px;
  padding: 14px 16px;
  grid-template-columns: 38px auto;
  grid-template-areas: 'number name';
`;

ArticleTopShoesDesktop.Number = styled.div`
  grid-area: number;
  height: 16px;
`;

ArticleTopShoesDesktop.Name = styled.div`
  grid-area: name;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  height: 42px;
`;
